import {fetchWithState, getFetchedJSON} from '~/misc/fetch';
import toLegacyLoad from '~/misc/toLegacyLoad';
const markCreatedAt = (since) => {
  const searchSince = new Date(since);
  return (item) => {
    const createdAt = item.created_at || (searchSince - item.age);
    return toLegacyLoad(item, createdAt);
  };
};


export const getLoads =  (getState, {
  equipment, pickUp,
  offset, limit,
  sort, sortOrder
}) => {
  return fetchWithState(getState, {
    url: '/tl/v2/shipment/state/count/detail',
    method: 'POST',
    body: {
      equipment,
      pickUpState: pickUp,
      offset, limit,
      sortOrder: {
        field: sort,
        sortOrder,
      }
    }
  }, false).then(getFetchedJSON).then((response) => {
    return {
      shipments: response.data && response.data
        .filter(item => item)
        .map(markCreatedAt(Date.now())),
      total_shipments: response.data.length,
      search_since: Date.now(),
    }
  })
}


// WEBPACK FOOTER //
// ./src/modules/cityRatioList/api.js